module.exports = __webpack_public_path__ + "img/bust.6980288c.png";